import { RootState } from "../store";

export const selectChecklist = (state: RootState) => state.checklist;

export const selectQuestionMap = (state: RootState) => state.checklist.questionMap;

export const selectQuestionLocationMap = (state: RootState) => state.checklist.questionLocationMap;

export const selectChecklistLoading = (state: RootState) => state.checklist.loading;

export const selectChecklistError = (state: RootState) => state.checklist.error;

export const selectQuestionById = (questionId: string) => (state: RootState) => {
    return state.checklist.questionMap[questionId];
};

export const selectQuestionLocationById = (questionId: string) => (state: RootState) => {
    return state.checklist.questionLocationMap[questionId];
};
